import { isValidForm } from "./_is_valid_form";

if (document.getElementById("reviewSlider")) {
    // VARIABLES

    const messages = {
        1: "Oh no! Please tell us how we can improve.",
        2: "Unsatisfactory. Please tell was how we can improve.",
        3: "Acceptable, but please let us know what we can do better.",
        4: "Good. Any ideas for improvements are appreciated.",
        5: "Awesome. We're thrilled you enjoyed the experience!",
    };

    const events = ["keyup", "select", "change"];

    // spans
    const starMessage = document.getElementById("starMessage");
    const currentStepMessage = document.getElementById("currentStepMessage");
    const formErrorMessage = document.getElementById("formErrorMessage");

    // buttons
    const nextButton = document.getElementById("reviewFormNextButton");
    const prevButton = document.getElementById("reviewFormPrevButton");

    //slides
    const reviewSlideOne = document.getElementById("slide-1");
    const reviewSlideTwo = document.getElementById("slide-2");
    const reviewSlideThree = document.getElementById("slide-3");
    const reviewSlideFour = document.getElementById("slide-4");

    //counters
    let currentSlide = 1;

    // star stuff
    const stars = document.querySelectorAll("input.star");
    const starsWrapper = document.getElementById("reviewStars");

    //slider stuff
    const slider = document.getElementById("reviewSlider");

    // comment textarea
    const copyTextSpanBtn = document.getElementById("copyTextSpan");
    const textArea = document.getElementById("comment");

    // set hidden link input's value 
    let uuid = document.querySelector('input[name=uuid]').value;
    let link = `${window.location.host}/quick_review/result/${uuid}`;
    document.querySelector('input[name=link]').value = link;

    // HELPER FUNCTIONS
    const isFiveStarReview = () => {
        if (document.getElementById("rating-star-5").checked === true) {
            return true;
        } else {
            return false;
        }
    };

    const disableElement = (element) => {
        element.disabled = true;
    };

    const enableElement = (element) => {
        element.disabled = false;
    };

    const hideButton = (button) => {
        disableElement(button);
        button.classList.remove("opacity-50");
        button.classList.remove("opacity-100");
        button.classList.add("opacity-0");
    };

    const showButton = (button) => {
        enableElement(button);
        button.classList.remove("opacity-0");
        button.classList.remove("opacity-50");
        button.classList.add("opacity-100");
    };

    const fiftyPercentOpacity = (button) => {
        button.classList.remove("opacity-0");
        button.classList.remove("opacity-100");
        button.classList.add("opacity-50");
        disableElement(button);
    };

    const setReviewStep = () => {
        currentStepMessage.innerHTML = `Step ${currentSlide} of 3`;
    };

    const translateXSlider = () => {
        slider.style.transform = `translateX(${
            (currentSlide - 1) * -33.33333
        }%)`;
    };

    const disableStars = () => {
        for (let i = 0; i < stars.length; i++) {
            disableElement(stars[i]);
        }
    };

    const enableStars = () => {
        for (let i = 0; i < stars.length; i++) {
            enableElement(stars[i]);
        }
    };

    // INIT FUNCTION

    const init = () => {
        currentStepMessage.innerHTML = "Step 1 of 3";
        const params = new URLSearchParams(window.location.search);

        if (params.get("rating")) {
            let id = document.getElementById(params.get("rating"));
            id.checked = true;
        }
    };

    init();

    // EVENT LISTENERS
    events.forEach((event) => {
        starsWrapper.addEventListener(event, (e) => {
            if (isValidForm("slide-1") && isValidForm("reviewStars")) {
                showButton(nextButton, true);
            }

            if (isFiveStarReview()) {
                document
                    .getElementById("socialMediaLinks")
                    .classList.add("visible");
                document
                    .getElementById("socialMediaLinks")
                    .classList.remove("invisible");
                document
                    .getElementById("reviewFormSubmitMessage")
                    .classList.add("invisible");
                document
                    .getElementById("reviewFormSubmitMessage")
                    .classList.remove("visible");
            } else {
                document
                    .getElementById("socialMediaLinks")
                    .classList.remove("visible");
                document
                    .getElementById("socialMediaLinks")
                    .classList.add("invisible");
                document
                    .getElementById("reviewFormSubmitMessage")
                    .classList.add("visible");
                document
                    .getElementById("reviewFormSubmitMessage")
                    .classList.remove("invisible");
            }

            switch (e.target.id) {
                case "rating-star-1":
                    starMessage.innerHTML = messages[1];
                    break;
                case "rating-star-2":
                    starMessage.innerHTML = messages[2];
                    break;
                case "rating-star-3":
                    starMessage.innerHTML = messages[3];
                    break;
                case "rating-star-4":
                    starMessage.innerHTML = messages[4];
                    break;
                case "rating-star-5":
                    starMessage.innerHTML = messages[5];
                    break;
            }
        });
    });

    events.forEach((event) => {
        reviewSlideOne.addEventListener(event, () => {
            if (isValidForm("slide-1") && isValidForm("reviewStars")) {
                showButton(nextButton);
            } else {
                fiftyPercentOpacity(nextButton);
            }
        });
    });

    nextButton.addEventListener("click", (e) => {
        e.preventDefault();
        let fiveStarReview = isFiveStarReview();

        if (isValidForm(`slide-${currentSlide}`) && currentSlide < 3) {
            if (formErrorMessage.innerHTML != "&nbsp;") {
                formErrorMessage.innerHTML = "&nbsp;";
            }

            if (currentSlide === 1) {
                disableStars();
                if (prevButton.classList.contains("opacity-0")) {
                    showButton(prevButton);
                }

                if (fiveStarReview) {
                    document
                        .getElementById("socialMediaLinks")
                        .classList.add("visible");
                    document
                        .getElementById("socialMediaLinks")
                        .classList.remove("invisible");
                    document
                        .getElementById("reviewSteps")
                        .classList.remove("invisible");
                    document
                        .getElementById("reviewSteps")
                        .classList.add("visible");
                } else {
                    document
                        .getElementById("socialMediaLinks")
                        .classList.remove("visible");
                    document
                        .getElementById("socialMediaLinks")
                        .classList.add("invisible");
                    document
                        .getElementById("reviewSteps")
                        .classList.add("invisible");
                }
            }

            if (currentSlide === 2) {
                let form = document.getElementById("quickreviewform");
                prevButton.style.display = "none";
                let checkedInputValue = document.querySelector(
                    "#reviewStars input:checked"
                ).value;
                document.getElementById("starRating").value = checkedInputValue;
                form.submit();

                if (fiveStarReview) {
                    nextButton.innerHTML = "Submit";
                    let socialMediaButtons = document
                        .querySelectorAll('.socialMediaReviewLink');
                        socialMediaButtons.forEach(button => {
                            button.setAttribute('tabIndex', 0)
                        })
                } else {
                    hideButton(nextButton);
                    document
                        .getElementById("reviewFormSubmitMessage")
                        .classList.remove("invisible");
                    document
                        .getElementById("reviewFormSubmitMessage")
                        .classList.add("visible");
                }
            }

            currentSlide++;
            setReviewStep();
            translateXSlider();
        } else if (currentSlide === 3) {
            hideButton(nextButton);
            document
                .getElementById("socialMediaLinks")
                .classList.remove("visible");
            document
                .getElementById("socialMediaLinks")
                .classList.add("invisible");
            document
                .getElementById("reviewFormSubmitMessage")
                .classList.remove("invisible");
            document
                .getElementById("socialMediaLinks")
                .classList.add("visible");
            document.getElementById("reviewSteps").classList.add("invisible");
            document.getElementById("reviewSteps").classList.remove("visible");
        } else {
            formErrorMessage.innerHTML =
                "Please fill out the fields before continueing";
        }
    });

    prevButton.addEventListener("click", (e) => {
        e.preventDefault();
        currentSlide = currentSlide - 1;
        translateXSlider();
        showButton(nextButton);
        nextButton.innerHTML = "Next";
        setReviewStep();

        if (currentSlide == 1) {
            enableStars();
            hideButton(prevButton);
            nextButton.type = "text";
        }
    });

    // COPY TEXT TO CLIPBOARD ON CLICK AND ON INPUT
    const deselectAll = () => {
        var element = document.activeElement;

        if (element && /INPUT|TEXTAREA/i.test(element.tagName)) {
            if ("selectionStart" in element) {
                element.selectionEnd = element.selectionStart;
            }
            element.blur();
        }

        if (window.getSelection) {
            // All browsers, except IE <=8
            window.getSelection().removeAllRanges();
        } else if (document.selection) {
            // IE <=8
            document.selection.empty();
        }

        textArea.selectionStart = textArea.selectionEnd = textArea.value.length;
        textArea.focus();
    };

    const copyText = (input) => {
        input.select();
        document.execCommand("copy");
        deselectAll();
    };

    textArea.addEventListener("input", () => {
        copyText(textArea);
    });

    copyTextSpanBtn.addEventListener("click", () => {
        textArea.style = "opacity:0;";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        copyTextSpanBtn.querySelector("span").innerHTML = " Copied!";

        setTimeout(() => {
            copyTextSpanBtn.querySelector("span").innerHTML =
                "  Click here to copy your review";
        }, 2500);
    });
}

if (document.getElementById("quickreview")) {
    const quickReview = document.getElementById("quickreview");
    const links = quickReview.querySelectorAll("a");
    links.forEach((link) => {
        link.addEventListener("click", () => {
            let icon = link.querySelector("i");
            let num = Number(icon.id);
            let icons = quickReview.querySelectorAll("i");

            for (let i = num; i > 0; i--) {
                icons[i].style.color = "#fc0";
            }
        });
    });
}